export const getClassCategoryArray = (
  data,
  cashes,
  assets,
  forOptimisation,
) => {
  if (!data) return {};

  const getTotalSek = (id, amount) => {
    const total = cashes?.find((i) => i.ID === id)?.latest_value_sek * amount;
    return total;
  };

  const getAssetName = (classId, categoryId) => {
    if (classId) {
      return assets?.find((i) => i.ID === classId)?.name;
    } else if (categoryId) {
      return assets?.find((i) => i.financialAssetCategoryID === categoryId)
        ?.financialAssetCategory?.name;
    }
  };

  const hasCashes = forOptimisation
    ? false
    : data.some((el) => el?.portfolio_cashes?.length);

  const weightKey = hasCashes ? 'current_weight' : 'current_weight_fin';

  let resultArray = {};

  let cashesSum = 0;
  let cashesWeight = 0;

  for (const item of data) {
    item?.portfolio_cashes?.forEach((el) => {
      cashesSum = el?.value
        ? cashesSum + el.value
        : cashesSum + getTotalSek(el.instrument_id, el.amount);
      cashesWeight = cashesWeight + el[weightKey];
    });
  }
  let cashesArray = !hasCashes
    ? []
    : cashesSum
      ? [
          {
            financial_asset_id: cashes[0]?.financialAsset?.ID ?? 32,
            financial_asset_category_id: cashes[0]?.financialAsset?.financialAssetCategory?.ID ?? 26,
            value: cashesSum,
            [weightKey]: cashesWeight,
          },
        ]
      : [];

  let classArray = [];
  let categoryArray = [];

  for (const item of data) {
    item?.portfolio_content
      ?.filter((i) => !i.is_excluded)
      ?.concat(item?.unlisted_content ?? [], cashesArray)
      ?.forEach((el) => {
        const idx = classArray.findIndex(
          (item) => item.financial_asset_id === el.financial_asset_id,
        );
        const idy = categoryArray.findIndex(
          (item) =>
            item.financial_asset_category_id === el.financial_asset_category_id,
        );

        if (idx === -1) {
          classArray.push({
            financial_asset_id: el.financial_asset_id,
            value: el.value,
            value_persent: el[weightKey],
            weight: el[weightKey],
          });
        } else {
          classArray[idx] = {
            ...classArray[idx],
            value: classArray[idx].value + el.value,
            value_persent: classArray[idx].value_persent + el[weightKey],
            weight: classArray[idx].weight + el[weightKey],
          };
        }

        if (idy === -1) {
          categoryArray.push({
            financial_asset_category_id: el.financial_asset_category_id,
            value: el.value,
            value_persent: el[weightKey],
            weight: el[weightKey],
          });
        } else {
          categoryArray[idy] = {
            ...categoryArray[idy],
            value: categoryArray[idy].value + el.value,
            value_persent: categoryArray[idy].value_persent + el[weightKey],
            weight: categoryArray[idy].weight + el[weightKey],
          };
        }
      });
  }

  const totalClassWeight = classArray.reduce(
    (acc, current) => current.weight + acc,
    0,
  );

  resultArray.class = classArray
    .map((i) => {
      const { financial_asset_id, value } = i;
      const obj = {
        name: getAssetName(financial_asset_id, null),
        value,
        value_persent: (i.value_persent * 100) / totalClassWeight,
        weight: (i.weight * 100) / totalClassWeight,
      };
      return obj;
    })
    .sort((a, b) => b.weight - a.weight);
  resultArray.category = categoryArray
    .map((i) => {
      const { financial_asset_category_id, value } = i;
      const obj = {
        name: getAssetName(null, financial_asset_category_id),
        value,
        value_persent: (i.value_persent * 100) / totalClassWeight,
        weight: (i.weight * 100) / totalClassWeight,
      };
      return obj;
    })
    .sort((a, b) => b.weight - a.weight);
  return resultArray;
};
